import './aboutMe.css'

function AboutMe() {
    return (
        <div id="am">
            <p>Welcome to OPwebDev, where we specialize in crafting exceptional online experiences.  Whether you're just starting to think about your professional website, or or want to enhance your existing site, we're your trusted partners with a wealth of  development expertise and dynamic designs. Our mission is to empower local businesses with a definitive online presence and distinct brand identity. Let us develop your vision into a compelling digital reality.</p>
        </div>
    )
}

export default AboutMe;